import { type MCPServerInfo } from '../../types';

const GraphitiServer: MCPServerInfo = {
  serverId: 'GRAPHITI',
  name: 'Graphiti',
  slug: 'graphiti',
  description: 'Graphiti MCP Server',
  source: {
    sourceType: 'REPOSITORY',
    type: 'OFFICIAL',
    repositoryUrl: 'mcp/knowledge-graph-mcp:latest',
    commitSha: 'latest',
    packageType: 'npm',
    packageName: ''
  },
  authenticationType: 'STATIC_CREDS',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: [
      'NEO4J_URI',
      'NEO4J_USER',
      'NEO4J_PASSWORD',
      'OPENAI_API_KEY',
      'MODEL_NAME'
    ],
    properties: {
      NEO4J_URI: {
        type: 'string',
        description: 'Neo4j connection URI',
        sensitive: false,
        default: 'example.com'
      },
      NEO4J_USER: {
        type: 'string',
        description: 'Neo4j username',
        sensitive: false,
        default: 'neo4j'
      },
      NEO4J_PASSWORD: {
        type: 'string',
        description: 'Neo4j password',
        sensitive: true,
        default: 'password'
      },
      OPENAI_API_KEY: {
        type: 'string',
        description: 'OpenAI API key',
        sensitive: true,
        default: 'sk-XXXXXXXX'
      },
      MODEL_NAME: {
        type: 'string',
        description: 'Model name for OpenAI',
        sensitive: false,
        default: 'gpt-4.1-mini'
      }
    }
  }
};

export default GraphitiServer;
